import type { RouteRecordRaw } from 'vue-router'

import { ROUTE_NAMES } from '~/constants/routes'

const routes = (): RouteRecordRaw[] => {
  return [
    {
      component: () => import('~/scopes/auth/pages/login/Login.vue'),
      name: ROUTE_NAMES.AUTH.LOGIN,
      path: '/bo-seller/login',
      meta: {
        layout: 'unauthenticated',
        owners: ['bot-squad-identity'],
        userLoadingStrategy: 'never',
      },
    },
    {
      component: () => import('~/scopes/auth/pages/register/Register.vue'),
      name: ROUTE_NAMES.AUTH.REGISTER,
      path: '/bo-seller/register',
      meta: {
        layout: 'unauthenticated',
        owners: ['bot-squad-seller-experience-front'],
      },
    },
  ]
}

export default routes
